module.exports = __webpack_public_path__ + "img/do_status.2cc96e65.svg";